import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import SavedOrder from '../components/Header/SavedOrder'

function SavedOrderPage() {
  return (
    <>
    <Navbar/>
    <SavedOrder/>
    </>
  )
}

export default SavedOrderPage
